// eslint-disable-next-line no-shadow
export enum FiletypeEnum {
  PDF = 'application/pdf',
  IMG = 'image/png',
}
